import React from 'react';
import './Features.css';
import frecuraImage from '../assets/icons/Sushi.png';
import foodImage from '../assets/icons/Vegan Food.png';
import deliveryImage from '../assets/icons/Scooter.png';
import pickupImage from '../assets/icons/Address.png';

const Features = () => {
  const features = [
    {
      id: 1,
      title: 'FRESCURA',
      description: 'Ingredientes frescos seleccionados para tu sushi.',
      image: frecuraImage
    },
    {
      id: 2,
      title: 'Comida Deliciosa',
      description: 'Sabor auténtico que se disfruta en cada bocado.',
      image: foodImage
    },
    {
      id: 3,
      title: 'DELIVERY',
      description: 'Tu sushi favorito, rápido y seguro hasta tu puerta.',
      image: deliveryImage
    },
    {
      id: 4,
      title: 'PICK UP',
      description: 'Ordena online y recoge sin filas ni esperas.',
      image: pickupImage
    }
  ];

  return (
    <section className="features">
      <div className="container">
        <div className="features-grid">
          {features.map((feature) => (
            <div key={feature.id} className="feature-card">
              <div className="feature-image">
                <img src={feature.image} alt={feature.title} />
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;

